
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Palmtree, Ship, Building2 } from 'lucide-react';

const MiamiPage = () => {
  return (
    <CityPageTemplate
      city="Miami"
      state="Florida"
      stateAbbr="FL"
      population="470,000+"
      majorIndustries={["international trade", "tourism", "finance", "real estate", "healthcare"]}
      businessChallenges={[
        "International workforce visa and compliance issues",
        "Seasonal tourism business fluctuations",
        "Multi-lingual HR support requirements",
        "Hurricane and weather-related business continuity",
        "High employee turnover in hospitality sector"
      ]}
      peoSolutions={[
        "International employee visa and work authorization support",
        "Seasonal workforce management and flexible benefits",
        "Multi-lingual HR services and employee communications",
        "Business continuity and disaster recovery planning",
        "Hospitality industry specialized retention programs"
      ]}
      localBusinessTypes={[
        { name: "International Trade", description: "Import/export, logistics, customs" },
        { name: "Tourism & Hospitality", description: "Hotels, restaurants, attractions" },
        { name: "Finance", description: "Banking, investment, insurance" },
        { name: "Real Estate", description: "Development, management, sales" }
      ]}
      metaDescription="Find the best PEOs in Miami with The PEO App. Compare quotes from top Miami Professional Employer Organizations offering specialized HR solutions for international trade, tourism, and finance businesses."
      keyFeatures={[
        {
          icon: Ship,
          title: "International Trade Expertise",
          description: "Specialized HR solutions for Miami's international business community with visa support and cross-border employment compliance."
        },
        {
          icon: Palmtree,
          title: "Tourism Industry Focus",
          description: "Expert HR services for Miami's hospitality sector including seasonal workforce management and multilingual support."
        },
        {
          icon: Building2,
          title: "Hurricane Preparedness",
          description: "Business continuity planning and disaster recovery HR services for Miami's hurricane-prone business environment."
        }
      ]}
    />
  );
};

export default MiamiPage;
